import React, { Component } from 'react';
import Pagination, { PaginationProps } from '../../Pagination';

export type DataTablePaginationProps = {
  /** @var Passed from DataTable. Called to uncheck the Select All checkbox */
  onPageUpdate?: () => void;
} & PaginationProps;

class DataTablePagination extends Component<DataTablePaginationProps> {
  static displayName = 'DataTablePagination';

  onPageChange = (pageNumber: number, startItem: number, endItem: number) => {
    const { onPageChange, onPageUpdate } = this.props;
    if (onPageUpdate) {
      onPageUpdate(); // call DataTable to uncheck Select All checkbox
    }
    onPageChange(pageNumber, startItem, endItem);
  };

  onPageSizeChange = (pageSize: number) => {
    const { onPageSizeChange, onPageUpdate } = this.props;
    if (onPageUpdate) {
      onPageUpdate(); // call DataTable to uncheck Select All checkbox
    }
    onPageSizeChange(pageSize);
  };

  render() {
    return (
      <Pagination
        {...this.props}
        onPageChange={this.onPageChange}
        onPageSizeChange={this.onPageSizeChange}
      />
    );
  }
}

export default DataTablePagination;
